import {
    loadCustomerListModal,
    triggerCustomerListModal
} from "../../../default/global/js/salesperson/customerListModal";

window.addEventListener("load", (event) => {
    triggerCustomerListModal();

    if(document.body.dataset.customerNo === "" && !document.salespersonLoadInitialized){
        document.salespersonLoadInitialized = true;
        loadCustomerListModal();
    }
});

export function initSalespersonNavigation(container = document.querySelector(".itemlist--1")) {
    if (!container) return;

    function attachEnterHandler(input) {
        if (input.dataset.enterAttached) return;

        input.addEventListener('keydown', function(e) {
            if(e.key === 'Enter') {
                e.preventDefault();
                const form = input.closest('form');
                const inputs = Array.from(form.querySelectorAll('.js-quantity-value'));
                const index = inputs.indexOf(input);

                let nextInput = null;
                for (let i = index + 1; i < inputs.length; i++) {
                    if (!inputs[i].disabled) {
                        nextInput = inputs[i];
                        break;
                    }
                }

                if(nextInput) {
                    nextInput.focus();
                    nextInput.select();
                } else {
                    const nextForm = form.nextElementSibling;
                    if(nextForm) {
                        const nextToggle = nextForm.querySelector('.itemlistElement__toggle');
                        if(nextToggle) {
                            setTimeout(() => {
                                nextToggle.focus({preventScroll: false});
                                nextToggle.scrollIntoView({behavior: 'smooth', block: 'center'});
                            }, 10);
                        }
                    }
                }
            }
        });

        input.dataset.enterAttached = "true";
    }

    function attachToggleHandler(toggle) {
        if (toggle.dataset.toggleAttached) return;

        toggle.setAttribute("tabindex", "0");
        toggle.addEventListener('keydown', e => {
            const form = toggle.closest('form');
            if (!form) return;

            if (e.key === 'Enter') {
                e.preventDefault();
                console.log('Enter gedrückt auf Toggle');
                toggle.click();
            }

            if (e.key === 'Tab') {
                e.preventDefault();

                // wenn das aktuelle Formular aktiv ist → ins Input
                if (form.classList.contains('is-active')) {
                    console.log("Form ist aktiv, Tab → Input");

                    const focusWhenOpen = () => {
                        const inputs = Array.from(form.querySelectorAll('.js-quantity-value'))
                            .filter(input => !input.disabled);

                        if (inputs.length > 0) {
                            console.log('Fokus auf Input:', inputs[0]);
                            inputs[0].focus({ preventScroll: true });
                            inputs[0].select();
                            return true;
                        } else {
                            console.log('Noch keine Inputs, retry in 50ms...');
                            setTimeout(focusWhenOpen, 50);
                        }
                        return false;
                    };

                    if (!focusWhenOpen()) {
                        const obs = new MutationObserver(() => {
                            if (focusWhenOpen()) obs.disconnect();
                        });
                        obs.observe(form, { childList: true, subtree: true });
                    }
                }
                // wenn das Formular NICHT aktiv ist → zum nächsten Toggle springen
                else {
                    console.log("Form ist NICHT aktiv, Tab → nächstes Formular");

                    let nextForm = form.nextElementSibling;
                    while (nextForm && !nextForm.querySelector('.itemlistElement__toggle')) {
                        nextForm = nextForm.nextElementSibling;
                    }

                    const nextToggle = nextForm?.querySelector('.itemlistElement__toggle');
                    if (nextToggle) {
                        nextToggle.focus({ preventScroll: false });
                        nextToggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        console.log("Fokus auf nächsten Toggle");
                    }
                }
            }
        });

        toggle.dataset.toggleAttached = "true";
    }

    // Observer für dynamische Inputs und Toggles
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    if (node.matches("input[type='number']")) attachEnterHandler(node);
                    node.querySelectorAll?.("input[type='number']")?.forEach(attachEnterHandler);

                    if (node.matches(".itemlistElement__toggle")) attachToggleHandler(node);
                    node.querySelectorAll?.(".itemlistElement__toggle")?.forEach(attachToggleHandler);
                }
            });
        });
    });
    observer.observe(container, { childList: true, subtree: true });

    // Handler für Toggles initial zuweisen
    container.querySelectorAll(".itemlistElement__toggle").forEach(attachToggleHandler);
    container.querySelectorAll("input[type='number']").forEach(attachEnterHandler);
}

export function initSalespersonItemcardNavigation(container = document.querySelector('.itemcardBuybox')) {
    if (!container) return;

    function attachEnterHandler(input) {
        if (input.dataset.enterAttached) return;

        input.addEventListener('keydown', function(e) {
            if (e.key !== 'Enter') return;
            e.preventDefault();

            const form = input.closest('form');
            const inputs = Array.from(form.querySelectorAll('.js-quantity-value')).filter(i => !i.disabled);
            const index = inputs.indexOf(input);
            const nextInput = inputs[index + 1] ?? null;

            if (nextInput) {
                nextInput.focus();
                nextInput.select();
            }
        });

        input.dataset.enterAttached = "true";
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;
                if (node.matches('.js-quantity-value')) attachEnterHandler(node);
                node.querySelectorAll?.('.js-quantity-value')?.forEach(attachEnterHandler);
            });
        });
    });
    observer.observe(container, { childList: true, subtree: true });

    container.querySelectorAll('.js-quantity-value').forEach(attachEnterHandler);
}

document.addEventListener("DOMContentLoaded", () => {
    initSalespersonNavigation();
    initSalespersonItemcardNavigation();
});


